import PortalLogo from '../../assets/img/logo_acetrade_large.svg';

type Props = {
  className?: string;
};

const HeaderLogo = ({ className }: Props) =>
  (
    <img
      src={PortalLogo}
      alt="logo"
      id="AceTrade Logo"
      aria-label="AceTrade logo"
      className={className}
    />
  );
export default HeaderLogo;
